import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from './../../features/user/userSlice';
import { setFromWhereHompageActiveId } from './../../appSlice';
import { selectFilterData } from './../../features/mainFilter/selectors';
// import { updateMainFilter } from '../../features/mainFilter/mainFilterSlice';
import { findInArray } from '../../utilities/helpers';

const useInitializeFavorites = () => {
  const dispatch = useDispatch();
  const {
    searchEngine: { fromwhere: departures },
  } = useSelector(selectFilterData);

  useEffect(() => {
    const handleUserLoggedIn = () => {
      const userContext = JSON.parse(localStorage.getItem('hf_user'));
      dispatch(setUser(userContext));

      if (userContext?.user?.originAirports?.length && window.location.href.indexOf('fromwhere') === -1 && departures?.length > 1) {
        const selectedOrigins = departures.map(dep => ({
          ...dep,
          active: findInArray(userContext.user.originAirports, dep.id)
        }));
        const selectedOrigins2 = selectedOrigins.filter(item => item.active);
        const fromwhereEndDate = new Date();
        fromwhereEndDate.setDate(fromwhereEndDate.getDate() + 365);
        localStorage.setItem(
          'selectedFromwhere',
          JSON.stringify({ fromwhere: selectedOrigins2, date: fromwhereEndDate.getTime() })
        );
        const selectedIds = selectedOrigins2.map(d => d.id);
        dispatch(setFromWhereHompageActiveId(selectedIds));
        // dispatch(updateMainFilter({ filter: 'fromwhere', updatedValue: selectedOrigins })); 
      }
    };

    const handleInitUser = () => {
      const userContext = JSON.parse(localStorage.getItem('hf_user'));
      console.log('handled userContextSet');
      console.log('user context: ', userContext);

      if (userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth) {
        handleUserLoggedIn();
      }
    };

    handleInitUser();

    window.addEventListener('userLoggedIn', handleUserLoggedIn);
    window.addEventListener('userContextSet', handleInitUser);

    return () => {
      window.removeEventListener('userLoggedIn', handleUserLoggedIn);
      window.removeEventListener('userContextSet', handleInitUser);
    };
  }, [dispatch, departures]);
};

export default useInitializeFavorites;
